import { render, staticRenderFns } from "./HomePc.vue?vue&type=template&id=a285266a&scoped=true&"
import script from "./HomePc.vue?vue&type=script&lang=js&"
export * from "./HomePc.vue?vue&type=script&lang=js&"
import style0 from "./HomePc.vue?vue&type=style&index=0&id=a285266a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a285266a",
  null
  
)

export default component.exports